import React, { useContext, useState } from 'react';
import { Grid, TextField, InputAdornment } from '@mui/material';
import { MdClear } from 'react-icons/md';
import { LanguageContext } from '../../../../../../../libs/Context';

const AddOptions = (props) =>
{
	const { eachOptn, index, handleUpdate, options } = props;
	const [ txtVal, setTxtVal ] = useState<string>(eachOptn ?? '');
	const { language } = useContext(LanguageContext);

	const handleChange = (value) =>
	{
		setTxtVal(value);
		handleUpdate(index, value);
	};

	return (
		<Grid item spacing={1}>
			<TextField fullWidth
				variant='outlined'
				autoFocus={!txtVal}
				size='small'
				label={language?.enterOption}
				placeholder={language?.enterOption}
				margin='dense'
				onChange={(e) => handleChange(e?.target?.value.replace(/^\s+/, ''))}
				value={txtVal}
				InputProps={options?.length !== 1
					? {
						endAdornment : (
							<InputAdornment position='end'>
								<MdClear cursor={'pointer'} fontSize='var(--pixel20)'
									onClick={() => handleUpdate(index, txtVal, 'delete')}
								/>
							</InputAdornment>
						)
					}
					: {}}
			/>
		</Grid>
	);
};

export default AddOptions;
